import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './login/login.component';
import { TimerComponent } from './timer/timer.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    TimerComponent,
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    TimerComponent,
  ]
})
export class SharedModule { }
